<div id="modal-content-wrapper">
  <div class="card card-secondary card-outline">
    <div class="card-header bg-light" cdkDragBoundary="html" cdkDrag cdkDragRootElement=".cdk-overlay-pane"
      cdkDragHandle>
      <h4 class="card-title mb-0">{{this.titulo}}</h4>
      <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancelar()"><i class="fas fa-times"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-0">
      <div class="table-container p-3">
        <div class="row ">
          <div class="form-group col-md-12">
            <label for="nome" class="mb-1">Custos e Recursos</label>
            <div class="input-group input-group-sm">
              <input type="text" id="nome" class="form-control" [(ngModel)]="modelCustoRecursoPlanejamento.nome"
                maxlength="100" />
              <div class="input-group-append">
                <button type="button" class="btn btn-info" (click)="exibirModalCustoRecurso()">
                  <i class="fas fa-search"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row ">
          <div class="form-group col-md-12">
            <label for="valorUnitario" class="mb-1">Valor</label>
            <input type="text" class="form-control form-control-sm"
              [value]="formatarValorVisual(modelCustoRecursoPlanejamento.valorUnitario)" (input)="onInputValor($event)"
              (blur)="ajustarVisualizacao()" maxlength="15" />

          </div>
        </div>

        <div class="row ">
          <div class="form-group col-md-12">
            <label for="quantidade" class="mb-1">Quantidade</label>
            <input type="text" id="quantidade" class="form-control form-control-sm"
              [(ngModel)]="modelCustoRecursoPlanejamento.quantidade" maxlength="5"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
          </div>
        </div>

      </div>
    </div>
    <div class="card-footer">
      <div class="btn-group" [hidden]="visualizar">
          <button class="btn btn-primary btn-sm mr" (click)="salvar(false)">
              <i class="far fa-save"></i> Salvar
          </button>
          <button type="button" class="btn btn-primary btn-sm mr dropdown-toggle dropdown-icon" data-toggle="dropdown" aria-expanded="false"></button>
          <div class="dropdown-menu" role="menu">
              <a class="dropdown-item" (click)="salvar(false)">Salvar</a>
              <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
          </div>
      </div>
  
      <button type="button" class="btn btn-default btn-sm" (click)="cancelar()">
          <i class="fas fa-times"></i> {{visualizar ? 'Sair' : 'Cancelar' }}
      </button>
    </div>
  </div>
</div>